import { render, staticRenderFns } from "./DowntimeNotice.vue?vue&type=template&id=b27dcdca&scoped=true"
import script from "./DowntimeNotice.vue?vue&type=script&lang=ts"
export * from "./DowntimeNotice.vue?vue&type=script&lang=ts"
import style0 from "./DowntimeNotice.vue?vue&type=style&index=0&id=b27dcdca&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b27dcdca",
  null
  
)

export default component.exports